module.exports = __webpack_public_path__ + "img/arduino.76101f80.png";